"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const browser_1 = __importDefault(require("@hyperdx/browser"));
const core_1 = require("@material-ui/core");
const colors_1 = require("@material-ui/core/colors");
const Info_1 = __importDefault(require("@material-ui/icons/Info"));
const query_1 = require("@reduxjs/toolkit/query");
const react_1 = require("react");
const react_cookie_1 = require("react-cookie");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const config_1 = require("config");
const consumer_applications_v2_api_1 = require("consumer-applications-v2-api");
const context_1 = require("context");
const credit_portal_components_1 = require("credit-portal-components");
const hooks_1 = require("hooks");
const inline_colors_1 = require("inline-colors");
const utils_1 = require("utils");
const forms_1 = require("../../forms");
const api_1 = require("../../prove/views/utils/api");
const actions_1 = require("../actions");
const components_1 = require("../components");
const reducer_1 = require("../reducer");
function PersonalInfo({ moveToNextStep, allowChangePractice, showFindApplication, }) {
    //CUSTOM HOOKS
    const dispatch = (0, react_redux_1.useDispatch)();
    const { analytics } = (0, react_1.useContext)(context_1.AnalyticsContext);
    const [cookies] = (0, react_cookie_1.useCookies)(['proveAb', 'proveStoreAb', 'storeLinkCampaign']);
    const location = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    const [getBlackboxData] = (0, hooks_1.useIovation)();
    //REDUX STATE
    const practice = (0, react_redux_1.useSelector)(reducer_1.selectors.practice);
    const personalInfo = (0, react_redux_1.useSelector)(reducer_1.selectors.personalInfo);
    const creditApplicationOTA = (0, react_redux_1.useSelector)(reducer_1.selectors.creditApplication);
    const applicationEnvironment = (0, react_redux_1.useSelector)(reducer_1.selectors.applicationEnvironment);
    const proveVerify = (0, react_redux_1.useSelector)(reducer_1.selectors.proveVerify);
    const proveFail = (0, react_redux_1.useSelector)(reducer_1.selectors.proveFail);
    const proveBypass = (0, react_redux_1.useSelector)(reducer_1.selectors.proveBypass);
    //COMPONENT STATE
    const [screen, setScreen] = (0, react_1.useState)('INITIAL INFO');
    const [applicationId, setApplicationId] = (0, react_1.useState)('');
    const [isProvePrefilled, setIsProvePrefilled] = (0, react_1.useState)(false);
    const [formVals, setFormVals] = (0, react_1.useState)(undefined);
    const [sessionJson] = (0, react_1.useState)(proveVerify);
    const [sessionJsonFail] = (0, react_1.useState)(proveFail);
    const [isProveLoading, setIsProveLoading] = (0, react_1.useState)(false);
    const [proveSession, setProveSession] = (0, react_1.useState)(undefined);
    const [proveSessionFail, setProveSessionFail] = (0, react_1.useState)(undefined);
    const [creditApplicationPayloadData, setCreditApplicationPayloadData] = (0, react_1.useState)(null);
    const [showPreparingOfferModal, setShowPreparingOfferModal] = (0, react_1.useState)(false);
    const [submittingForm, setSubmittingForm] = (0, react_1.useState)(false);
    //API Hooks
    const { data: lenderRequirements, isError: isErrorLenderRequirements } = (0, consumer_applications_v2_api_1.useGetConsumerApplicationsV2CreditApplicationsApplicationIdLenderRequirementsQuery)(applicationId ? { applicationId } : query_1.skipToken);
    const [createCreditApplication, { data: creditApplication, isError: isErrorCreateCreditApplication },] = (0, consumer_applications_v2_api_1.usePostConsumerApplicationsV2CreditApplicationsCreateMutation)();
    const [prequalifyCreditApplication, { data: prequalification, isError: isErrorPrequalify },] = (0, consumer_applications_v2_api_1.usePostConsumerApplicationsV2CreditApplicationsApplicationIdPrequalifyMutation)();
    const [patchCreditApplication, { data: patchedCreditApplication, isError: isErrorPatchCreditApplication },] = (0, consumer_applications_v2_api_1.usePatchConsumerApplicationsV2CreditApplicationsApplicationIdMutation)();
    //HANDLERS
    const submitPrequalification = async (additionalInfoFormValues) => {
        const creditApplicationToUse = creditApplication
            ? creditApplication.creditApplication
            : creditApplicationOTA;
        const { consumer } = creditApplicationToUse
            ? creditApplicationToUse.locationServiceProviderPriorities
            : { consumer: [] };
        const acPrimePriority = consumer.find(({ productType }) => productType === config_1.PRODUCT_TYPE.AC_PRIME);
        await prequalifyCreditApplication({
            applicationId,
            postConsumerApplicationsV2CreditApplicationsApplicationIdPrequalify: {
                priority: acPrimePriority?.priority,
                iovationBlackBox: creditApplicationPayloadData.iovationBlackBox,
                prerequisiteTermsAccepted: creditApplicationPayloadData.prerequisiteTermsAccepted,
                purchaseAmount: personalInfo.purchaseAmount,
                monthlyHousingPayment: additionalInfoFormValues?.monthlyHousingPayment,
                housingType: additionalInfoFormValues?.housingType,
                primaryIncomeSource: additionalInfoFormValues?.primaryIncomeSource,
                grossAnnualIncome: additionalInfoFormValues?.grossAnnualIncome,
            },
        });
    };
    const handleSubmitAdditionalInfo = async (additionalInfoFormValues) => {
        setShowPreparingOfferModal(true);
        // Ensure the modal stays open for at least 2 seconds
        const minWait = new Promise((resolve) => setTimeout(resolve, 2000));
        await Promise.all([
            minWait,
            submitPrequalification(additionalInfoFormValues),
        ]);
        setShowPreparingOfferModal(false);
    };
    const handleChangeLocation = () => {
        history.push(config_1.CREDIT_PORTAL_URL);
    };
    const attachProveData = () => {
        const proveAbParticipantUuid = practice
            ? cookies.proveStoreAb?.participantUuid
            : cookies.proveAb?.participantUuid;
        let proveBypassToUse = undefined;
        if (proveBypass) {
            proveBypassToUse = proveBypass;
        }
        else if (proveSession || proveSessionFail) {
            proveBypassToUse = false;
        }
        return {
            proveSessionId: proveSession ?? proveSessionFail ?? undefined,
            proveBypassed: proveBypassToUse,
            ...(proveAbParticipantUuid
                ? { abParticipantUuid: proveAbParticipantUuid }
                : {}),
        };
    };
    const assembleCreditApplicationData = () => {
        const { alphaeonTerms, lenderTerms } = applicationEnvironment;
        const approvedTerms = (0, utils_1.approveTerms)(alphaeonTerms, lenderTerms);
        const blackboxData = getBlackboxData();
        const { consumer } = creditApplication?.creditApplication?.locationServiceProviderPriorities ||
            {};
        const acPrimePriority = consumer
            ? consumer.find(({ productType }) => productType === config_1.PRODUCT_TYPE.AC_PRIME)
            : null;
        const queryParams = new URLSearchParams(location.search);
        const partnerTrackingGuid = queryParams.get('partner_tracking_guid');
        const partnerIdentifier = queryParams.get('partner_identifier');
        const storeLinkCampaign = cookies.storeLinkCampaign;
        return {
            iovationBlackBox: blackboxData.blackbox,
            prerequisiteTermsAccepted: approvedTerms,
            partnerTrackingGuid: partnerTrackingGuid ?? '',
            partnerIdentifier: partnerIdentifier ?? '',
            ...(acPrimePriority ? { priority: acPrimePriority } : {}),
            ...(storeLinkCampaign
                ? {
                    storeLinkCampaign: storeLinkCampaign.campaignId,
                    otl: storeLinkCampaign.otl,
                }
                : {}),
            ...attachProveData(),
        };
    };
    const handleSubmit = async (prequalificationFormValues) => {
        dispatch((0, actions_1.setPersonalInfo)(prequalificationFormValues));
        const payloadData = assembleCreditApplicationData();
        setCreditApplicationPayloadData(payloadData);
        browser_1.default.setGlobalAttributes({
            locationId: practiceToUse?.locationId.toString() || '',
            storeNumber: practiceToUse?.adsStoreNumber.toString() || '',
            creditApplicationId: creditApplication?.creditApplication?.applicationId?.toString() || '',
            lastName: prequalificationFormValues.lastName,
            firstName: prequalificationFormValues.firstName,
            email: prequalificationFormValues.email,
            phone: prequalificationFormValues.primaryPhone,
            form: 'personal-info-v2',
        });
        if (!creditApplicationOTA) {
            //IF NOT AN OTA
            await createCreditApplication({
                postConsumerApplicationsV2CreditApplicationsCreate: {
                    ...prequalificationFormValues,
                    ...payloadData,
                    ...(practiceToUse ? { locationId: practiceToUse.locationId } : {}),
                },
            });
        }
        else {
            //IF AN OTA
            await patchCreditApplication({
                applicationId: creditApplicationOTA.applicationId,
                patchConsumerApplicationsV2CreditApplicationsApplicationId: {
                    ...prequalificationFormValues,
                    ...payloadData,
                    ...(practiceToUse ? { locationId: practiceToUse.locationId } : {}),
                },
            });
        }
    };
    // MISC JS
    const practiceFromState = location.state;
    const practiceToUse = !practice?.locationId && practiceFromState?.practice?.locationId
        ? practiceFromState.practice
        : practice;
    const initializeProve = async () => {
        setIsProveLoading(true);
        let getPreFillData;
        if (sessionJson && sessionJson.session_id === null) {
            getPreFillData = api_1.getProvePreFillOTA;
        }
        else if (sessionJson && sessionJson.session_id) {
            getPreFillData = api_1.getProvePreFill;
        }
        if (sessionJson && getPreFillData) {
            const preFillJson = await getPreFillData(sessionJson);
            const preFillRes = await preFillJson?.json();
            setProveSession(sessionJson.session_id ?? preFillRes.session_id); // Set Prove Session no matter what
            if (preFillRes?.message !== 'Prove pre-fill already used.' &&
                preFillRes?.message !== 'No CRM data available' &&
                preFillRes?.error_code === undefined) {
                setIsProvePrefilled(true); // Set Prove Bool
                dispatch((0, actions_1.setPersonalInfo)({
                    street1: preFillRes.address.address,
                    street2: preFillRes.address.address_extended,
                    city: preFillRes.address.city,
                    dateOfBirth: new Date(preFillRes.date_of_birth),
                    email: preFillRes.email,
                    firstName: preFillRes.first_name,
                    lastName: preFillRes.last_name,
                    primaryPhone: sessionJson.phone_number,
                    ...(preFillRes.ssn_last_4
                        ? { ssn: `XXXXX${preFillRes.ssn_last_4}` }
                        : {}),
                    state: preFillRes.address.region,
                    zip: preFillRes.address.zipcode,
                }));
            }
            else {
                setIsProveLoading(false);
                dispatch((0, actions_1.setProveFail)({
                    ...sessionJson,
                }));
                dispatch((0, actions_1.clearProveVerify)());
                dispatch((0, actions_1.clearProveApp)());
                dispatch((0, actions_1.setPersonalInfo)({
                    primaryPhone: (sessionJson && sessionJson.phone_number) ?? '',
                }));
                // Redirect if no prefill available or error
                history.push({
                    pathname: '/credit-portal/apply/wizard',
                    search: location.search,
                });
            }
        }
        setProveSessionFail(sessionJson?.session_id ?? sessionJsonFail?.session_id); // Set Prove Session ID no matter what
        setIsProveLoading(false);
    };
    // Effects
    (0, react_1.useEffect)(() => {
        analytics?.track('WizardSessionStart', {});
        if (config_1.PATH.PROVE !== null) {
            initializeProve();
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (creditApplication &&
            creditApplication.creditApplication?.applicationId) {
            setApplicationId(creditApplication.creditApplication.applicationId);
        }
        else if (patchedCreditApplication && creditApplicationOTA) {
            setApplicationId(creditApplicationOTA.applicationId);
        }
    }, [creditApplication, patchedCreditApplication]);
    (0, react_1.useEffect)(() => {
        if (lenderRequirements) {
            if (lenderRequirements.collectAdditionalInfo) {
                setScreen('ADDITIONAL INFO');
            }
            else {
                submitPrequalification();
            }
        }
    }, [lenderRequirements]);
    (0, react_1.useEffect)(() => {
        if (isErrorCreateCreditApplication ||
            isErrorLenderRequirements ||
            isErrorPatchCreditApplication ||
            isErrorPrequalify) {
            setSubmittingForm(false);
        }
    }, [
        isErrorCreateCreditApplication,
        isErrorLenderRequirements,
        isErrorPatchCreditApplication,
        isErrorPrequalify,
    ]);
    (0, react_1.useEffect)(() => {
        if (prequalification && !showPreparingOfferModal) {
            dispatch((0, actions_1.setPrequalification)(prequalification));
            setSubmittingForm(false);
            const { applicationStatus, applicationServiceProviderPriority, lenderNextStepUrl, lenderStatusMessage, lenderRequestReferenceId, offers, } = prequalification;
            dispatch((0, actions_1.setLenderReferenceId)(lenderRequestReferenceId));
            analytics?.track('SubmitApplication', {});
            if (isProvePrefilled) {
                dispatch((0, actions_1.clearProveFail)()); // Clear Prove Fail
                dispatch((0, actions_1.clearProveVerify)()); // Clear Prove Verify
                // Only formVals were edited
                if (formVals) {
                    if (sessionJson) {
                        (0, api_1.postProveVerifyApplicantData)({
                            session_id: sessionJson.session_id ||
                                (proveSession ? proveSession : proveSessionFail) ||
                                (proveSessionFail ? proveSessionFail : ''),
                            pre_fill_data: {
                                first_name: formVals.firstName,
                                last_name: formVals.lastName,
                                date_of_birth: formVals.dateOfBirth,
                                email: formVals.email,
                                address: {
                                    address: formVals.street1,
                                    address_extended: formVals.street2 ?? '',
                                    city: formVals.city,
                                    region: formVals.state,
                                    zipcode: formVals.zip,
                                },
                            },
                        });
                    }
                }
            }
            const adsOffer = offers?.find((offer) => offer.serviceProviderName === 'ADS');
            const imprintOffer = offers?.find((offer) => offer.serviceProviderName === 'Imprint');
            if (applicationStatus === 'prequalified') {
                moveToNextStep(creditApplicationPayloadData);
            }
            else if (applicationStatus === 'prequalified_account_exists') {
                history.push(config_1.PRE_QUALIFICATION_ACCOUNT_EXISTS_URL);
            }
            else if (applicationStatus === 'pending' &&
                lenderStatusMessage === config_1.BREAD_LENDER_STATUS.STEP_UP_NEEDED) {
                history.push(config_1.STEP_UP_REQUIRED_URL);
            }
            else if (applicationStatus === 'pending') {
                history.push(config_1.PRE_QUALIFICATION_INFORMATION_REQUIRED_URL);
            }
            else if (applicationStatus === 'pending_approval') {
                if (imprintOffer && imprintOffer.offerType === 'step_up_pend') {
                    moveToNextStep(creditApplicationPayloadData);
                }
                else {
                    history.push({
                        pathname: config_1.ACCESS_LOAN_URL,
                        state: {
                            lenderNextStepUrl,
                            modalType: 'prequal',
                        },
                    });
                }
            }
            else {
                if (adsOffer) {
                    const statusMessage = adsOffer?.offerType === 'disqualified'
                        ? 'DISQUALIFIED'
                        : 'NOT PREQUALIFIED';
                    history.push({
                        pathname: config_1.PRE_QUALIFICATION_DECLINED_ADS_ONLY_URL,
                        state: {
                            lenderStatusMessage: statusMessage,
                        },
                    });
                }
                else if (imprintOffer) {
                    history.push({
                        pathname: config_1.PRE_QUALIFICATION_DECLINED_IMPRINT_ONLY_URL,
                        state: { email: personalInfo.email, aanUrl: imprintOffer.aanUrl },
                    });
                }
                else if (applicationServiceProviderPriority?.productType === 'installment') {
                    history.push(config_1.PRE_QUALIFICATION_DECLINED_URL);
                }
                else {
                    history.push({
                        pathname: config_1.PRE_QUALIFICATION_DECLINED_ADS_ONLY_URL,
                        state: {
                            lenderStatusMessage,
                        },
                    });
                }
            }
        }
    }, [prequalification, showPreparingOfferModal]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(components_1.PreparingOfferModal, { isOpen: showPreparingOfferModal, setIsOpen: setShowPreparingOfferModal }), screen === 'INITIAL INFO' && ((0, jsx_runtime_1.jsxs)("div", { className: "application-instructions", children: [(0, jsx_runtime_1.jsxs)("div", { className: "info-header", children: [(0, jsx_runtime_1.jsxs)("p", { children: ["Find out now if you ", (0, jsx_runtime_1.jsx)("span", { children: "pre-qualify" }), (0, jsx_runtime_1.jsx)("sup", { children: "**" }), " without impacting your credit."] }), (0, jsx_runtime_1.jsx)("p", { children: "It's quick, easy, and secure with instant results, including your credit limit." })] }), (0, jsx_runtime_1.jsxs)("ul", { className: "info-content", children: [practiceToUse &&
                                practiceToUse.name &&
                                practiceToUse.locationId &&
                                !window.location.host.includes('iframe') && ((0, jsx_runtime_1.jsxs)("li", { className: "info", children: [creditApplicationOTA && personalInfo ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("b", { children: practiceToUse.name }), " has sent a one-time pre-qualification form for ", personalInfo.firstName, ' ', personalInfo.lastName, "."] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["You've selected practice ", (0, jsx_runtime_1.jsx)("b", { children: practiceToUse.name }), "."] })), allowChangePractice && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["If this is incorrect,", ' ', (0, jsx_runtime_1.jsx)("button", { onClick: handleChangeLocation, children: "click here" }), ' ', "to find a different practice."] }))] })), (0, jsx_runtime_1.jsxs)("li", { children: ["If your credit is locked or frozen, you'll need to remove the freeze before applying.", (0, jsx_runtime_1.jsx)("div", { className: "tooltip-container", children: (0, jsx_runtime_1.jsx)(core_1.Tooltip, { enterTouchDelay: 0, placement: "left", title: (0, jsx_runtime_1.jsx)("p", { style: {
                                                    fontSize: '14px',
                                                    color: inline_colors_1.INLINE_COLORS.whiteBase,
                                                }, children: "If you placed a freeze on your credit file, please contact each credit reporting agency directly to remove the credit freeze before going through the apply process." }), children: (0, jsx_runtime_1.jsx)(core_1.IconButton, { className: "icon-button", children: (0, jsx_runtime_1.jsx)(Info_1.default, { style: { color: colors_1.blue[800] } }) }) }) })] }), showFindApplication && ((0, jsx_runtime_1.jsxs)("li", { children: ["If you have already started an application and would like to complete it, please", ' ', (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: config_1.APPLICATION_FINDER_URL, children: "click here" }), "."] }))] }), (0, jsx_runtime_1.jsx)(forms_1.PrefilledPersonalInfoForm, { data: personalInfo, handleSubmit: handleSubmit, practice: practice, isProvePrefilled: isProvePrefilled, setFormVals: setFormVals, isProveLoading: isProveLoading, fieldsToExclude: applicationEnvironment?.fieldsToExclude, showAdditionalTerms: applicationEnvironment?.showAdditionalTerms, isSubmittingForm: submittingForm, setIsSubmittingForm: setSubmittingForm }), (0, jsx_runtime_1.jsx)(credit_portal_components_1.ServiceProviderDisclosures, {})] })), screen === 'ADDITIONAL INFO' && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(forms_1.AdditionalInfoForm, { handleSubmit: handleSubmitAdditionalInfo }) }))] }));
}
exports.default = PersonalInfo;
